import React, { Component } from 'react';
import P from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Redirect } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import { string, object } from 'yup';

import Button from 'components/Button/';
import GraphQLErrorMessage from 'components/form/GraphQLErrorMessage/';
import ErrorMsg from 'components/form/ErrorMsg/';
import transformErrors from 'utils/transformErrors';
import config from 'config';
import {
  CREATE_GROUP_MUTATION,
  VERIFY_EMAIL_MUTATION,
  LOGIN_MUTATION,
} from 'gql/mutations';

import './VerifyEmail.css';

const schema = object().shape({
  code:
    string()
      .min(6, 'Code must be 6 characters')
      .max(6, 'Code must be 6 characters')
      .test(
        'is-number',
        'Code can only be numbers',
        code => /^[0-9]*$/g.test(code),
      )
      .required('Code is a required field'),
});

class VerifyEmail extends Component {
  state = {
    createdGroupId: null,
  };

  render() {
    const { createdGroupId } = this.state;
    const { verifyEmailMutation, createGroupMutation,
      loginMutation, email, password } = this.props;

    if (createdGroupId) return <Redirect to={`/update-group/${createdGroupId}`} />;

    return (
      <div className="VerifyEmail">
        <div className="VerifyEmail-main">
          <h2 className="VerifyEmail-heading">We need to verify your email address</h2>
          <div className="VerifyEmail-bc">
            Please enter the 6 digit code we sent to:
            <b className="ml-2">{email}</b>
          </div>

          <Formik
            validationSchema={schema}
            initialValues={{ code: '' }}
            onSubmit={async (values, { setSubmitting, setErrors }) => {
              const { code } = values;
              try {
                // Verify Email
                await verifyEmailMutation({
                  variables: {
                    input: { code, email },
                  },
                });
  
                // Login
                const { data } = await loginMutation({
                  variables: {
                    input: { email, password }
                  }
                });
                const accessToken = data.login.session.id;
                localStorage.setItem("accessToken", JSON.stringify(accessToken));
  
                // Create Group
                const name = localStorage.getItem('groupName') || '';
                const summary = localStorage.getItem('groupDesc') || '';
                const type = localStorage.getItem('groupType') || 'community-group';
                const industry = localStorage.getItem('groupIndustry') || '';

                const { data: { saveGroup: { group } } } = await createGroupMutation({
                  variables: {
                    input: {
                      name,
                      summary,
                      type,
                      industry,
                    },
                  },
                });

                localStorage.removeItem('groupName');
                localStorage.removeItem('groupDesc');
                localStorage.removeItem('groupType');
                localStorage.removeItem('groupIndustry');

                // Hack way of changing route + reloading the page after setting accessToken
                window.location.href = `${config.WEB_URL}/management-portal/update-group/${group.id}`;
              }
              catch (err) {
                setErrors(transformErrors(err));
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting, values, errors }) => (
              <Form>
                <div className="VerifyEmail-field">
                  <label htmlFor="code">Enter your 6 digit code below</label>
                  <Field
                    id="code"
                    name="code"
                    placeholder="Enter your verification code"
                  />
                </div>
                <ErrorMsg name="code" />

                <GraphQLErrorMessage errors={errors} />
                <Button
                  className="VerifyEmail-submit"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Verify
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  }
}

VerifyEmail.propTypes = {
  verifyEmailMutation: P.func.isRequired,
  createGroupMutation: P.func.isRequired,
};

export default compose(
  graphql(VERIFY_EMAIL_MUTATION, { name: 'verifyEmailMutation' }),
  graphql(LOGIN_MUTATION, { name: 'loginMutation' }),
  graphql(CREATE_GROUP_MUTATION, { name: 'createGroupMutation' }),
)(VerifyEmail);
